module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paula Quinn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('I', [_vm._v("New York Times")]), _vm._v(" bestselling author "), _c('B', [_vm._v("Paula Quinn")]), _vm._v(" lives in New York with her three beautiful children, three over-protective chihuahuas, and a loud umbrella cockatoo. She loves to read romance and science fiction and has been writing since she was eleven.  She loves all things medieval, but it is her love for Scotland that pulls at her heartstrings.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/121txTT/images/9781455519484.jpg?1733085643105",
      "alt": "This image is the cover for the book Scandalous Secret of Abigail MacGregor, Highland Heirs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scandalous Secret of Abigail MacGregor, Highland Heirs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A LADY'S MISSION . . . "), _c('br'), _c('br'), _vm._v(" Known for her beauty and boldness, Abigail MacGregor must preserve her clan's dangerous secret: that her mother is the true heir to the English Crown. If the wrong people find out, it will mean war for her beloved Scotland. To keep peace, she embarks for London, unprepared for the treachery that awaits-especially from her wickedly handsome escort. He is the enemy, but his slow, sensuous kisses entice her beyond reason . . . "), _c('br'), _c('br'), _vm._v(" A WARRIOR'S TEMPTATION"), _c('br'), _c('br'), _vm._v(" General Daniel Marlow, loyal knight and the kingdom's most desirable hero, would rather be on the battlefield than transporting a spoiled Highland lass. But Abby MacGregor is unlike any woman he's ever met, in a ballroom or in his bedroom. Captivated by her daring spirit and seduced by her lovely innocence, Daniel must choose between betraying his queen or giving up the woman who would steal his country-and his traitorous heart.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grand Central Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0